import lazyWithRetry from 'utils/lazyWithRetry';

// project imports
// import ErrorBoundary from './ErrorBoundary';   // unused — see the commented-out route blocks below
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
// import PagesLayout from 'layout/Pages';
// import SimpleLayout from 'layout/Simple';

// import { SimpleLayoutType } from 'config';

// import path from 'path/win32';   // leftover from the template, nothing uses it


// Weepee Accounts
const AccountsSearch = Loadable(lazyWithRetry(() => import('pages/weepee/accounts/search')));
const AccountsCreate = Loadable(lazyWithRetry(() => import('pages/weepee/accounts/create')));
const GroupSearch = Loadable(lazyWithRetry(() => import('pages/weepee/group/search')));
const GroupAdd = Loadable(lazyWithRetry(() => import('pages/weepee/group/create')));
const GroupAddAccounts = Loadable(lazyWithRetry(() => import('pages/weepee/group/addaccounts')));

// Weepee Numbers
const NumbersSearch = Loadable(lazyWithRetry(() => import('pages/weepee/numbers/search')));
const NumbersAdd = Loadable(lazyWithRetry(() => import('pages/weepee/numbers/add')));
const NumbersAddUnused = Loadable(lazyWithRetry(() => import('pages/weepee/numbers/addunused')));
const NumbersMove = Loadable(lazyWithRetry(() => import('pages/weepee/numbers/move')));
const NumbersDelete = Loadable(lazyWithRetry(() => import('pages/weepee/numbers/delete')));
const ReversedScreeningAdd = Loadable(lazyWithRetry(() => import('pages/weepee/reversed-screening/add')));

// Weepee Numbering plans (numberingplan-be / -int, straight to the source)
const NumberingLookup = Loadable(lazyWithRetry(() => import('pages/weepee/numbering/lookup')));
const NumberingBlocks = Loadable(lazyWithRetry(() => import('pages/weepee/numbering/blocks')));

// Weepee Ports (cross-reseller admin overview — read-only)
const PortsOverview = Loadable(lazyWithRetry(() => import('pages/weepee/ports/overview')));

// Weepee Rates (rates-int / rates-be, through admin-proxy)
const RatesInternational = Loadable(lazyWithRetry(() => import('pages/weepee/rates/international')));
const RatesNational = Loadable(lazyWithRetry(() => import('pages/weepee/rates/national')));

// Weepee Carriers (rates-providers — "Providers" in v3-admintool)
const Carriers = Loadable(lazyWithRetry(() => import('pages/weepee/carriers')));

// Weepee Rate lookup (rates-master — "Rates lookup" in v3-admintool)
const RateLookup = Loadable(lazyWithRetry(() => import('pages/weepee/rates/lookup')));

// Weepee Switches (v3-admintool — "Switch Versies")
const Switches = Loadable(lazyWithRetry(() => import('pages/weepee/switches')));

// Weepee Monthly / Daily Stats (stats-monthly-daily)
const Stats = Loadable(lazyWithRetry(() => import('pages/weepee/stats')));

// Weepee Finance (v3-admintool — the monthly figures)
const FinanceOverview = Loadable(lazyWithRetry(() => import('pages/weepee/finance/overview')));
const FinanceCarriers = Loadable(lazyWithRetry(() => import('pages/weepee/finance/carriers')));
const FinanceResellers = Loadable(lazyWithRetry(() => import('pages/weepee/finance/resellers')));
const FinanceWholesales = Loadable(lazyWithRetry(() => import('pages/weepee/finance/wholesales')));

// Weepee Route Overrides (rates-master, live routing)
const OverridesNumbers = Loadable(lazyWithRetry(() => import('pages/weepee/overrides/numbers')));
const OverridesCarriers = Loadable(lazyWithRetry(() => import('pages/weepee/overrides/carriers')));

// Weepee Vouchers
const VouchersAdd = Loadable(lazyWithRetry(() => import('pages/weepee/vouchers/add')));

// Weepee Resellers
const ResellerAdd = Loadable(lazyWithRetry(() => import('pages/weepee/reseller/create')));
const ResellerSearch = Loadable(lazyWithRetry(() => import('pages/weepee/reseller/search')));

// Weepee Resellers
const WholesaleAdd = Loadable(lazyWithRetry(() => import('pages/weepee/wholesale/create')));
const WholesaleSearch = Loadable(lazyWithRetry(() => import('pages/weepee/wholesale/search')));

// User Management
const UsersListPage = Loadable(lazyWithRetry(() => import('pages/weepee/user-management/list')));
const UserCreatePage = Loadable(lazyWithRetry(() => import('pages/weepee/user-management/create')));

// Weepee banking
const SepaPaymentPage = Loadable(lazyWithRetry(() => import('pages/weepee/banking/sepa-payment')));

// AUTH
// The auth pages are routed from LoginRoutes, not from here — kept commented
// so the list stays visible if these ever move back under a layout route.
// const AuthLogin = Loadable(lazyWithRetry(() => import('pages/auth/firebase/login')));
// const AuthRegister = Loadable(lazyWithRetry(() => import('pages/auth/firebase/register')));
// const AuthForgotPassword = Loadable(lazyWithRetry(() => import('pages/auth/firebase/forgot-password')));
// const AuthResetPassword = Loadable(lazyWithRetry(() => import('pages/auth/firebase/reset-password')));
// const AuthCheckMail = Loadable(lazyWithRetry(() => import('pages/auth/firebase/check-mail')));
// const AuthCodeVerification = Loadable(lazyWithRetry(() => import('pages/auth/firebase/code-verification')));
// const AuthSetup2FA = Loadable(lazyWithRetry(() => import('pages/auth/firebase/setup-2fa')));


//const MaintenanceError = Loadable(lazyWithRetry(() => import('pages/maintenance/404')));
//const MaintenanceError500 = Loadable(lazyWithRetry(() => import('pages/maintenance/500')));
//const MaintenanceUnderConstruction = Loadable(lazyWithRetry(() => import('pages/maintenance/under-construction')));
//const MaintenanceComingSoon = Loadable(lazyWithRetry(() => import('pages/maintenance/coming-soon')));

//const AppContactUS = Loadable(lazyWithRetry(() => import('pages/contact-us')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (

          <DashboardLayout />

      ),
      children: [
        // WEEPEE STATS
        //{
        //  path: 'statistics',
        //  children: [
        //    {
        //      path: 'general',
        //      element: <StatisticsGeneral />
        //    },
        //    {
        //      path: 'carrier',
        //      element: <StatisticsCarrier />
        //    },
        //    {
        //      path: 'wholesale',
        //      element: <StatisticsWholesale />
        //    },
        //    {
        //      path: 'reseller',
        //      element: <StatisticsReseller />
        //    }
        //  ]
        //},
        // WEEPEE RATES
        // The rate lookup (rates-master) is a separate system and is not part
        // of this screen — see the note in rates.service.ts.
        {
          path: 'rates',
          children: [
            {
              path: 'international',
              element: <RatesInternational />
            },
            {
              path: 'national',
              element: <RatesNational />
            },
            {
              path: 'carriers',
              element: <Carriers />
            },
            {
              path: 'lookup',
              element: <RateLookup />
            }
          ]
        },
        // WEEPEE SWITCHES (v3-admintool, which stays the receiver)
        {
          path: 'switches',
          element: <Switches />
        },
        // WEEPEE MONTHLY / DAILY STATS (stats-monthly-daily)
        {
          path: 'stats',
          element: <Stats />
        },
        // WEEPEE FINANCE (v3-admintool)
        {
          path: 'finance',
          children: [
            {
              path: 'overview',
              element: <FinanceOverview />
            },
            {
              path: 'carriers',
              element: <FinanceCarriers />
            },
            {
              path: 'resellers',
              element: <FinanceResellers />
            },
            {
              path: 'wholesales',
              element: <FinanceWholesales />
            }
          ]
        },
        // WEEPEE NUMBERING PLANS
        {
          path: 'numbering',
          children: [
            {
              path: 'lookup',
              element: <NumberingLookup />
            },
            {
              path: 'blocks',
              element: <NumberingBlocks />
            }
          ]
        },
        // WEEPEE ROUTE OVERRIDES (rates-master)
        {
          path: 'overrides',
          children: [
            {
              path: 'numbers',
              element: <OverridesNumbers />
            },
            {
              path: 'carriers',
              element: <OverridesCarriers />
            }
          ]
        },
        // WEEPEE PORTS (cross-reseller admin overview)
        {
          path: 'ports',
          children: [
            {
              path: 'overview',
              element: <PortsOverview />
            }
          ]
        },
        // WEEPEE ACCOUNTS
        {
          path: 'accounts',
          children: [
            {
              path: 'search',
              element: <AccountsSearch />
            },
            {
              path: 'create',
              element: <AccountsCreate />
            }
          ]
        },
        // WEEPEE PROACCOUNTS
        {
          path: 'group',
          children: [
            {
              path: 'search',
              element: <GroupSearch />
            },
            {
              path: 'add',
              element: <GroupAdd />
            },
            {
              path: 'addtopro',
              element: <GroupAddAccounts />
            }
          ]
        },
        // WEEPEE RESELLERS
        {
          path: 'resellers',
          children: [
            {
              path: 'search',
              element: <ResellerSearch />
            },
            {
              path: 'add',
              element: <ResellerAdd />
            }
          ]
        },
        // WEEPEE WHOLESALES
        {
          path: 'wholesales',
          children: [
            {
              path: 'search',
              element: <WholesaleSearch />
            },
            {
              path: 'add',
              element: <WholesaleAdd />
            }
          ]
        },
        // WEEPEE NUMBERS
        {
          path: 'numbers',
          children: [
            {
              path: 'search',
              element: <NumbersSearch />
            },
            {
              path: 'add',
              element: <NumbersAdd />
            },
            {
              path: 'add-unused',
              element: <NumbersAddUnused />
            },
            {
              path: 'move',
              element: <NumbersMove />
            },
            {
              path: 'delete',
              element: <NumbersDelete />
            }
          ]
        },
        // WEEPEE REVERSED SCREENING
        {
          path: 'reversed-screening',
          children: [
            {
              path: 'add',
              element: <ReversedScreeningAdd />
            }
          ]
        },
        // WEEPEE VOUCHERS
        {
          path: 'vouchers',
          children: [
            {
              path: 'add',
              element: <VouchersAdd />
            }
          ]
        },
        // WEEPEE BANKING
        {
          path: 'banking',
          children: [
            {
              path: 'sepa-payment',
              element: <SepaPaymentPage />
            }
          ]
        },
        // USER MANAGEMENT
        {
          path: 'user-management',
          children: [
            {
              path: 'list',
              element: <UsersListPage />
            },
            {
              path: 'create',
              element: <UserCreatePage />
            }
          ]
        }
      ]
    }
  ]
};

export default MainRoutes;